import { styled } from '@mui/material/styles';
import { Row } from 'global/components/row';

export const AlertsDropContainer = styled('div', {
  shouldForwardProp: (p) => !['isMobileXS', 'windowSize'].includes(p),
})(({ isMobileXS, windowSize }) => ({
  width: isMobileXS ? windowSize.innerWidth - 40 : windowSize.innerWidth * 0.5,
  maxWidth: 500,
  height: isMobileXS ? windowSize.innerHeight - 50 : windowSize.innerHeight * 0.6,
}));

export const AlertsDropHeaderRow = styled(Row)(({ theme }) => ({
  boxSizing: 'border-box',
  padding: theme.spacing(1),
}));
